<template>
   <div>
     <div class="radio-box" v-for="(item,index) in radios" :key="item.id" >
       <span class="radio" :class="{'on':item.isChecked}"></span>
       <input v-model="payType" :value="item.value" class="input-radio" :checked='item.isChecked' @click="check(index)"
         type="radio">{{item.label}}
     </div>
   </div>

</template>

<script>
  export default {
    name: 'radio',
    components: {
    },
    data() {
      return {
        payType: '开启',
        radios: [{
            label: '开启',
            value: '开启',
            isChecked: true,
          },
          {
            label: '停止',
            value: '停止',
            isChecked: false,
          },
        ]
      }
    },
    methods: {
      check(index) {
        // 先取消所有选中项
        this.radios.forEach((item) => {
          item.isChecked = false;
        });
        //再设置当前点击项选中
        this.payType = this.radios[index].value;
        // 设置值，以供传递
        this.radios[index].isChecked = true;
        console.log(this.payType);
      },
      loadData() {

        _this.payType = data.FPayType
        if (data.FPayType === "开启") {
          _this.$set(_this.radios[0], 'isChecked', true)
          _this.$set(_this.radios[1], 'isChecked', false)
        } else {
          _this.$set(_this.radios[0], 'isChecked', false)
          _this.$set(_this.radios[1], 'isChecked', true)
        }
      }
    }
  }
</script>

<style>
  .radio-box {
    display: inline-block;
    position: relative;
    height: 25px;
    line-height: 25px;
    margin-right: 5px;
  }

  .input-radio {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 25px;
    height: 25px;
    cursor: pointer;
    left: 0px;
    outline: none;
    -webkit-appearance: none;
  }

  .radio {
    display: inline-block;
    width: 25px;
    height: 25px;
    vertical-align: middle;
    cursor: pointer;
    background-image: url(../../../assets/img/car/circle.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .on {
    background-image: url(../../../assets/img/car/circle_click1.png);
    background-size: 100% 100%;

  }

</style>
